import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = { style: {"width":"70px"} }
const _hoisted_4 = {
  key: 0,
  class: "allocated-text"
}

import Api from "@/services/api/ApiServiceFabrick";
import SpotCreateModal from "@/components/SpotParts/SpotCreateModal.vue";
import {
  WORK_EVENT_TYPES,
} from "@/services/consts";
import {
  round,
  dateToDayAndTime,
} from "@/services/functions";
import {
  getAddress,
} from "@/services/Geocoder";
import WorkloadUpdateModal from "@/components/DailyReportUpdateModalParts/WorkloadUpdateModal";

import { ref, computed } from "vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyReportWorkListViewRow',
  props: {
  modelValue: {},
  index: { type: Number },
  operationOffice: {},
  updateAuthority: {},
  editable: {
    type: Boolean,
  },
  showFlash: {
    type: Function,
  },
  createSpotAuthority: {
    type: Boolean,
  },
  isWaitingForSave: {
    type: Boolean,
    default: false
  },
},
  emits: [
  "update:modelValue",
  "setRefuelingAmount",
  "startEdit",
  "remove"
],
  setup(__props, { emit: __emit }) {

const SPOT_READONLY_KEYS = ['management_office', 'operation_office', 'address', 'map'];

const props = __props

const emits = __emit;

const item = ref(props.modelValue);

const leavingTime = computed(() => {
  if (item.value.work == 'leaving_warehouse') {
    return ''
  }
  if (!item.value.start_time) {
    return ''
  }
  return dateToDayAndTime(new Date(item.value.start_time))
});
const workingTime = computed(() => {
  if (item.value.work == 'leaving_warehouse') {
    return ''
  }
  return item.value.working_time
})
const drivingTime = computed(() => {
  if (item.value.work == 'leaving_warehouse') {
    return ''
  }
  return item.value.driving_time
})
const returningTime = computed(() => {
  if (item.value.work == 'returning_warehouse') {
    return ''
  }
  if (!item.value.end_time) {
    return ''
  }
  return dateToDayAndTime(new Date(item.value.end_time))
})
const mileage = computed(() => {
  if (item.value.work == 'leaving_warehouse') {
    return ''
  }
  if (item.value.mileage == '-' || item.value.added_at) {
    return '-'
  }
  if (!item.value.mileage) {
    return '0.00'
  }
  return roundForView(item.value.mileage)
})
const isDisplayEditButton = computed(() => {
  return item.value.work != 'leaving_warehouse' &&
    props.editable &&
    props.updateAuthority
})

const showWorkloadButton = computed(() => {
  return item.value.work == 'loading' ||
    item.value.work == 'unloading'  ||
    item.value.work == 'refueling';
})
const isDisplayDeleteButton = computed(() => {
  return item.value.work != 'leaving_warehouse' && (
    item.value.adding ||
    item.value.allocated
  ) &&
  props.updateAuthority
})

const spotParams = computed(() => {
  return {
    operation_office_id: props.operationOffice.id,
    management_officeable_id: props.operationOffice.managementOfficeId,
    management_officeable_type: props.operationOffice.managementOfficeType,
    latitude: item.value.latitude,
    longitude: item.value.longitude,
    radius: null,
  }
})

const canCreateSpot = computed(() => {
  return props.createSpotAuthority &&
    !item.value.spot_id &&
    !(item.value.adding || item.value.work == 'stopping');
})

async function assignAddress(item) {
  if (item) {
    const result = await getAddress({
      lat: item.latitude,
      lng: item.longitude,
    });
    item.address = result;
  }
  return item;
}
function roundForView(num) {
  return round(num, 2).toFixed(2)
}

function setWorkId(workId) {
  item.value.work_id = workId;
  emits('update:modelValue', item.value);
}

function setRefuelingAmount() {
  emits("setRefuelingAmount")
}

function edit() {
  emits('startEdit');
}

function remove() {
  emits('remove');
}

function showFlashMessage(msg: string, flag: string, isAutoClose: boolean) {
  let className = 'info';
  let message = i18n.global.t('pages.dailyReports.messages.successRegistSpot');
  if (flag == 'error') {
    className = 'error';
    message = i18n.global.t('pages.dailyReports.errorMessage.registSpot');
  }

  props.showFlash(message, true, className, isAutoClose);
}

function callbackCreatedSpot(res) {
  Api().updateWorkSpot(item.value.delivery_plan_id, {
     work: item.value.work,
     date_time: item.value.start_time,
     spot_id: res.id,
  }).then(() => {
    item.value.spot_id = res.id;
  }).catch(() => {
    props.showFlash(i18n.global.t('pages.dailyReports.errorMessage.updateWorkSpot'), true, 'error', true);
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(props.index), 1),
    _createElementVNode("td", null, _toDisplayString(_unref(WORK_EVENT_TYPES)[item.value.work]) + _toDisplayString(item.value.edited_at ? '*' : ''), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.value.spot_name), 1),
        (canCreateSpot.value)
          ? (_openBlock(), _createBlock(SpotCreateModal, {
              key: 0,
              isCreateAuthority: __props.createSpotAuthority,
              isOperationOffice: true,
              showFlash: showFlashMessage,
              item: spotParams.value,
              onUpdateItem: callbackCreatedSpot,
              readOnlyKeys: SPOT_READONLY_KEYS,
              preMount: assignAddress,
              draggable: false
            }, {
              button: _withCtx(() => [
                _createVNode(_component_v_tooltip, {
                  text: _unref(i18n).global.t('pages.dailyReports.updateModal.workList.registSpot')
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("span", _mergeProps({ class: "material-symbols-outlined pin-drop" }, props), " pin_drop ", 16)
                  ]),
                  _: 1
                }, 8, ["text"])
              ]),
              _: 1
            }, 8, ["isCreateAuthority", "item"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("td", null, _toDisplayString(leavingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(returningTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(workingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(drivingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(mileage.value), 1),
    _createElementVNode("td", null, [
      (showWorkloadButton.value)
        ? (_openBlock(), _createBlock(_unref(WorkloadUpdateModal), {
            key: 0,
            isWaitingForSave: props.isWaitingForSave,
            workItem: item.value,
            operationOfficeId: __props.operationOffice.id,
            updateAuthority: __props.updateAuthority,
            onSetWorkId: setWorkId,
            onSetRefuelingAmount: setRefuelingAmount
          }, null, 8, ["isWaitingForSave", "workItem", "operationOfficeId", "updateAuthority"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_3, [
      (isDisplayEditButton.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "update-dailyreport-button edit-button",
            onClick: edit
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "material-symbols-outlined" }, " edit ", -1)
          ]))]))
        : _createCommentVNode("", true),
      (isDisplayDeleteButton.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "update-dailyreport-button delete-button",
            onClick: remove
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      (item.value.allocated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.updateModal.workList.autoAssignment')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})